import React, { useState } from "react";

const filters = {
  Csharp: "filterIcons/csharp.png",
  Cplus: "filterIcons/cplus.png",
  C: "filterIcons/c.png",
  Python: "filterIcons/py.png",
  Web: "filterIcons/web.png",
  React: "filterIcons/react.png",
  GameDev: "filterIcons/game.png",
  App: "filterIcons/software.png",
};

export default function FilterList({ selectedTagz, setselectedTags }) {

  const toggleTag = (tag) => {
    setselectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  }

  return (
    <div className="filters">
      {Object.entries(filters).map(([name, image]) => (
        <div
          key={name}
          className={`filterDiv ${selectedTagz.includes(name)
            ? "active"
            : ""
            }`}
          onClick={() => toggleTag(name)}
        >
          <img src={image} alt={name} className="" />
          <div className="">{name}</div>
        </div>
      ))}
    </div>
  );
}
